/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillPreCheckRespVo } from './BillPreCheckRespVo';
import {
    BillPreCheckRespVoFromJSON,
    BillPreCheckRespVoFromJSONTyped,
    BillPreCheckRespVoToJSON,
    BillPreCheckRespVoToJSONTyped,
} from './BillPreCheckRespVo';

/**
 * 
 * @export
 * @interface ResponseBillPreCheckRespVo
 */
export interface ResponseBillPreCheckRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseBillPreCheckRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseBillPreCheckRespVo
     */
    message?: string;
    /**
     * 
     * @type {BillPreCheckRespVo}
     * @memberof ResponseBillPreCheckRespVo
     */
    data?: BillPreCheckRespVo;
}

/**
 * Check if a given object implements the ResponseBillPreCheckRespVo interface.
 */
export function instanceOfResponseBillPreCheckRespVo(value: object): value is ResponseBillPreCheckRespVo {
    return true;
}

export function ResponseBillPreCheckRespVoFromJSON(json: any): ResponseBillPreCheckRespVo {
    return ResponseBillPreCheckRespVoFromJSONTyped(json, false);
}

export function ResponseBillPreCheckRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseBillPreCheckRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : BillPreCheckRespVoFromJSON(json['data']),
    };
}

export function ResponseBillPreCheckRespVoToJSON(json: any): ResponseBillPreCheckRespVo {
    return ResponseBillPreCheckRespVoToJSONTyped(json, false);
}

export function ResponseBillPreCheckRespVoToJSONTyped(value?: ResponseBillPreCheckRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': BillPreCheckRespVoToJSON(value['data']),
    };
}

